import { allRoutes } from './allRoutes';

export class RouteAccess {
  constructor(access) {
    const obj = {
      super_admin: this.superAdmin(),
      admin: this.admin(),
      manager: this.admin(),
      consultant: this.consultant(),
      user: this.user(),
      representative: this.representative(),
      '': [],
    };
    return obj[access?.toLowerCase()] ?? [];
  }

  superAdmin() {
    return [
      allRoutes.homeSuperAdmin,
      allRoutes.simulation,
      allRoutes.simulationEdit,
      allRoutes.redrural,
      allRoutes.profile,
      allRoutes.simulatorSuperAdmin,
      allRoutes.resale,
      allRoutes.resaleDetails,
      allRoutes.resaleSettings,
      allRoutes.simulationSuperAdmin,
      allRoutes.simulationSuperAdminDetail,
      allRoutes.redscoreSuperAdmin,
      allRoutes.contratos,
      allRoutes.contratosNew,
      allRoutes.contratosEdit,
    ];
  }

  admin() {
    return [
      allRoutes.home,
      allRoutes.team,
      allRoutes.contacts,
      allRoutes.form,
      allRoutes.formSucessBussines,
      allRoutes.formSucessClient,
      allRoutes.red25,
      allRoutes.redtri,
      allRoutes.redsafra,
      allRoutes.proposal,
      allRoutes.profile,
      allRoutes.createUser,
      allRoutes.customers,
      allRoutes.customerFormCreate,
      allRoutes.customerFormEdit,
      allRoutes.clientTable,
      allRoutes.businessTable,
      allRoutes.redscore,
      allRoutes.redrural,
      allRoutes.redCoins,
      allRoutes.redConsultsList,
      allRoutes.createUserWithoutConsult,
      allRoutes.payments,
      allRoutes.simulation,
      allRoutes.simulationEdit,
      allRoutes.contratos,
      allRoutes.contratosNew,
      allRoutes.contratosEdit,
    ];
  }

  consultant() {
    return [
      allRoutes.home,
      allRoutes.red25,
      allRoutes.redtri,
      allRoutes.redsafra,
      allRoutes.form,
      allRoutes.formSucessBussines,
      allRoutes.formSucessClient,
      allRoutes.proposal,
      allRoutes.profile,
      allRoutes.createUser,
      allRoutes.customers,
      allRoutes.customerFormCreate,
      allRoutes.customerFormEdit,
      allRoutes.clientTable,
      allRoutes.redscore,
      allRoutes.redrural,
      allRoutes.redCoins,
      allRoutes.redConsultsList,
      allRoutes.payments,
      allRoutes.simulation,
      allRoutes.simulationEdit,
    ];
  }

  user() {
    return [allRoutes.home, allRoutes.proposalUser, allRoutes.profile];
  }

  representative() {
    return [
      allRoutes.home,
      allRoutes.redrural, // simulador
      allRoutes.red25, // simulador RED25
      allRoutes.redtri, // simulador Tri
      allRoutes.form, // cadastro de empresa
      allRoutes.formSucessBussines, // sucesso no cadastro
    ];
  }
}
